import React from "react";
import { Sprout, Medal, Gem, Trophy } from "lucide-react";
import { isTierId, type TierId } from "@/lib/tiers";

/**
 * Tier color system (identity is never color-alone — every badge carries its
 * icon + label):
 *   Starter → neutral gray · Oficial → blue · Elite → purple · Top 5 → gold
 */
const TIER_BADGE_CONFIG: Record<TierId, { label: string; className: string; icon: React.ElementType }> = {
  starter: {
    label: "Starter",
    className: "bg-zinc-400/10 text-zinc-300 border-zinc-400/25",
    icon: Sprout,
  },
  oficial: {
    label: "Oficial",
    className: "bg-blue-400/10 text-blue-300 border-blue-400/25",
    icon: Medal,
  },
  elite: {
    label: "Elite",
    className: "bg-purple-400/10 text-purple-300 border-purple-400/25",
    icon: Gem,
  },
  top5: {
    label: "Top 5 do Mês",
    className: "bg-amber-400/10 text-amber-300 border-amber-400/30",
    icon: Trophy,
  },
};

interface InfluencerTierBadgeProps {
  tierId: string | null | undefined;
  className?: string;
}

export const InfluencerTierBadge: React.FC<InfluencerTierBadgeProps> = ({ tierId, className = "" }) => {
  if (!isTierId(tierId)) {
    return (
      <span
        className={`inline-flex items-center gap-1 rounded-full border border-white/10 bg-white/5 px-2.5 py-0.5 text-xs font-medium text-muted-foreground ${className}`}
      >
        Sem categoria
      </span>
    );
  }

  const { label, className: tierClassName, icon: Icon } = TIER_BADGE_CONFIG[tierId];
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${tierClassName} ${className}`}
    >
      <Icon className="h-3 w-3" />
      {label}
    </span>
  );
};

export default InfluencerTierBadge;
